import { useSelector } from 'react-redux';
import { selectAuthRole } from '../store/authSlice';
import { ROLES } from '../constants/roles';

export function usePermissions() {
  const role = useSelector(selectAuthRole);
  return {
    canEdit: role === ROLES.EDITOR,
    canCreate: role === ROLES.EDITOR,
  };
}
